<template>
  <div id="page-user-list">
    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <div class="
          btn-add-new
          p-3
          mb-4
          mr-4
          rounded-lg
          cursor-pointer
          flex
          items-center
          justify-center
          text-lg
          font-medium
          text-base text-primary
          border border-solid border-primary
        " @click="$router.push('/quotation-add')">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add New</span>
      </div>
      <!-- Merge: Moderator / Administrator only -->
      <div v-if="canMerge" class="
          btn-add-new
          p-3
          mb-4
          mr-4
          rounded-lg
          cursor-pointer
          flex
          items-center
          justify-center
          text-lg
          font-medium
          text-base text-primary
          border border-solid border-primary
        " @click="mergePopupActive = true">
        <feather-icon icon="GitMergeIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Merge</span>
      </div>
    </div>

    <merge-quotations v-if="canMerge" :active.sync="mergePopupActive" @merged="onMerged" />
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              ">
              <span class="mr-2">{{
                currentPage * paginationPageSize - (paginationPageSize - 1)
              }}
                -
                {{
                  operationsData.length - currentPage * paginationPageSize > 0
                  ? currentPage * paginationPageSize
                  : operationsData.length
                }}
                of {{ operationsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="
            sm:mr-4
            mr-0
            sm:w-auto
            w-full
            sm:order-normal
            order-3
            sm:mt-0
            mt-4
          " v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
        <vs-button v-if="displayExport != false" class="mb-4 md:mb-0 mr-2" @click="gridApi.exportDataAsCsv()">Export as
          CSV</vs-button>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef"
        :rowData="operationsData" rowSelection="multiple" colResizeDefault="shift" :animateRows="true"
        :floatingFilter="true" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @grid-ready="onGridReady">
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

// Store Module
import moduleQuotationList from "@/store/quotation/moduleOperationList.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

// Merge popup (Moderator / Administrator)
import MergeQuotations from "./MergeQuotations.vue";

export default {
  components: {
    AgGridVue,
    vSelect,
    MergeQuotations,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      displayExport: false,
      mergePopupActive: false,
      searchQuery: "",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      suppressSizeToFit: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "REF",
          valueGetter: function (params) {
            return "#" + params.data.ref;
          },
          filter: true,
          width: 100,
          cellRendererFramework: "CellRendererLink",
        },
        {
          headerName: "DATE",
          valueGetter: function (params) {
            return params.data.quotedate;
          },
          sort: "DESC",
          filter: true,
          width: 160,
        },
        {
          headerName: "EXPECTED DATE",
          valueGetter: function (params) {
            return params.data.expected;
          },
          filter: true,
          width: 175,
        },/*
        {
          headerName: "TYPE",
          valueGetter: function (params) {
            if (params.data.isquotationparent) {
              if (parseInt(params.data.count_enfant) > 1)
                return "Parent of " + params.data.count_enfant + " quotes";
              else return "Parent of " + params.data.count_enfant + " quote";
            } else if (params.data.isenfant)
              return "Child of #" + params.data.isenfant;
            return "Normal";
          },
          //field: 'iscompany',
          filter: true,
          width: 160,
          cellRendererFramework: "CellRendererStatus",
        },*/
        {
          headerName: "STATUS",
          valueGetter: function (params) {
            if (params.data.isquotationparent) {
              if (parseInt(params.data.count_enfant) > 0)
                return "Child assigned";
              else if (params.data.status == "Approved")
                return "Parent approved ⟶ Awaiting child";
              else if (params.data.status == "Pending")
                return "Parent pending ⟶ Awaiting approval";
              else if (params.data.status == "Cancelled")
                return "Parent Cancelled";
              else return params.data.status;
            } else {
              let textToDisplay = "Pending ⟶ Awaiting approval";
              if (!params.data.expected && params.data.invoiceispaid) textToDisplay = "Delivered and Paid";
              else {
                if (params.data.status == "Approved") {
                  textToDisplay = "Approved ⟶ Awaiting invoicing";
                  if (params.data.idadvance_quotation) {
                    if (params.data.advanceispaid != 0)
                      textToDisplay = "Advance paid ⟶ Awaiting transport";
                    else textToDisplay = "Advance invoice ⟶ Awaiting Payment";
                  }
                  if (params.data.idbalance_quotation) {
                    if (params.data.balanceispaid != 0)
                      textToDisplay = "Invoice paid ⟶ Awaiting transport";
                    else textToDisplay = "Final Invoice ⟶ Awaiting Payment";
                  }
                  if (params.data.idinvoice_quotation) {
                    if (params.data.invoiceispaid != 0)
                      textToDisplay = "Invoice paid ⟶ Awaiting transport";
                    else textToDisplay = "Invoice done ⟶ Awaiting payment";
                  }

                  if (params.data.idtransport)
                    textToDisplay = "Transport assigned";
                  if (
                    parseInt(params.data.deliverydays) >= 0 &&
                    parseInt(params.data.transportstart) >= 0
                  )
                    textToDisplay = "Transport in progress";
                  if (parseInt(params.data.deliverydays) < 0) {
                    if (
                      params.data.balanceispaid != 0 ||
                      params.data.invoiceispaid != 0
                    )
                      textToDisplay = "Delivered and Paid";
                    else textToDisplay = "Delivered and not paid";
                  }
                } else if (params.data.status == "Cancelled")
                  textToDisplay = "Cancelled";
              }
              return textToDisplay;
            }
          },
          //field: 'iscompany',
          filter: true,
          width: 340,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          headerName: "CLIENT",
          field: "client",
          filter: true,
          width: 250,
        },
        {
          headerName: "TAG",
          valueGetter: function (params) {
            return params.data.quotation_tag
          },
          filter: true,
          width: 100,
        },
        {
          headerName: "VOL. (m3)",
          valueGetter: function (params) {
            if (parseInt(params.data.count_enfant) > 0) {
              if (parseFloat(params.data.volume) > 0)
                return Math.abs(
                  parseFloat(params.data.volume) /
                  parseInt(params.data.count_enfant)
                )
                  .toFixed(1)
                  .toLocaleString();
              else return "N/A";
            } else {
              if (parseFloat(params.data.volume) > 0)
                return Math.abs(params.data.volume).toFixed(1).toLocaleString();
              else return "N/A";
            }
          },
          filter: true,
          width: 140,
          type: "numericColumn",
        },
        {
          headerName: "PRICE (EUR)",
          valueGetter: function (params) {
            if (parseInt(params.data.count_enfant) > 0) {
              if (parseFloat(params.data.price) > 0)
                return Math.abs(
                  parseFloat(params.data.price) /
                  parseInt(params.data.count_enfant)
                )
                  .toFixed(2)
                  .toLocaleString();
              else return "N/A";
            } else {
              if (parseFloat(params.data.price) > 0)
                return Math.abs(params.data.price).toFixed(2).toLocaleString();
              else return "N/A";
            }
          },
          filter: true,
          width: 140,
          type: "numericColumn",
        },
        {
          headerName: "Broker",
          field: "company_name",
          filter: true,
          width: 120,
        },
        {
          headerName: "Country",
          field: "country",
          filter: true,
          width: 120,
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 110,
          cellRendererFramework: "CellRendererActions",
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  computed: {
    // The Merge button is for Moderators and Administrators. The API enforces
    // the same rule (isModeratorOrAdmin) — this only hides the entry point.
    canMerge() {
      const roles = (localStorage.getItem("login-roles") || "").toLowerCase();
      return roles.includes("admin") || roles.includes("moderator");
    },
    operationsData() {
      if (!this.$store.state.quotationList) {
        return [];
      }
      return this.$store.state.quotationList.operations || [];
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 100;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
        { label: "All", value: "all" };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onGridReady(params) {
      this.gridApi = params.api;
    },
    // The merged-away quotations are now back to Pending (they keep their lines):
    // reload so the grid shows the main quotation with its new totals and the
    // others with their new status.
    onMerged() {
      this.$vs.loading();
      this.$store
        .dispatch("quotationList/fetchQuotations")
        .then(() => {
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
          console.error(err);
        });
    },
  },
  mounted() {
    // Le gridApi sera initialisé dans onGridReady
    if (this.gridOptions.api) {
      this.gridApi = this.gridOptions.api;
    }
  },
  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }
    this.$vs.loading();
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.displayExport = true;
    }
    if (!moduleQuotationList.isRegistered) {
      this.$store.registerModule("quotationList", moduleQuotationList);
      moduleQuotationList.isRegistered = true;
    }
    this.$store
      .dispatch("quotationList/fetchQuotations")
      .then((response) => {
        this.$vs.loading.close();
      })
      .catch((err) => {
        console.error(err);
      });
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
